import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { TicketStates, TicketTypes } from ".";
import TicketsAPI from "../../lib/API/TicketsAPI";

const MyTickets = () => {

    const history = useHistory();

    const [state, setState] = useState({
        tickets: null,
        reachedEnd: false,
        page: 0
    })

    useEffect(() => {
        loadTickets()
    }, [])

    const goToTicket = (id) => {
        history.push('/support/mytickets/' + id);
    }    

    const loadTickets = () => {
        TicketsAPI.GetMyTickets(state.page + 1)
            .then(({ data }) => {
                setState({
                    tickets: (state.tickets || []).concat(data),
                    page: state.page + 1,
                    reachedEnd: data.length == 0
                });
            })
            .catch(() => alert('An error occured, try to refresh'));
    }

    return (
        <>
            <div className="products-search">

                <h3>Support</h3>
                <div className="d-flex justify-content-center align-items-center">
                    <Link to={"/support/mytickets"} className="h4">My Tickets</Link>
                    <span className="h5"> | </span>
                    <Link to={"/support"} className="h5">New ticket</Link>
                </div>
            </div>

            {state.tickets && <div className="cart ">
                <div className="container row">
                    <div className="col">
                        <table className="orders-table items w-100 mb-3">
                            <thead>
                                <tr>
                                    <td>Title</td>
                                    <td style={{ width: "10%" }} className="text-center">Date</td>
                                    <td className="text-left">Topic</td>
                                    <td>Status</td>
                                    <td style={{ width: "192px" }}></td>
                                </tr>
                            </thead>
                            <tbody>
                                {state.tickets.map((ticket) => (
                                    <tr key={ticket.id} className="order-row" onClick={() => goToTicket(ticket.id)}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <h6 style={{ flex: 1 }}><Link to={'/orders/' + ticket.id}>{ticket.title}</Link></h6>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <h6 style={{ flex: 1 }}>{moment(ticket.date).format('MMM DD')}</h6>
                                        </td>
                                        <td>{TicketTypes[ticket.type]}</td>
                                        <td>
                                            <p>{TicketStates[ticket.state]}</p>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>

                                ))}
                            </tbody>
                        </table>

                    </div>
                    {!state.reachedEnd && (
                        <div className="row text-center">
                            <div className="col">
                                <button class="btn-black" onClick={loadTickets}>Load More</button>
                            </div>
                        </div>
                    )}
                </div>
            </div>}
        </>
    )
}

export { MyTickets };